package dev.inmo.config_creator.features.json_builder.client.ui.schema

import androidx.compose.runtime.Composable

@Composable
actual fun BeforeJsonDrawer() {
}